import { SvgIcon, SvgIconProps } from "@mui/material";

export const ClockIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
      fill="#1E90FF"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M15.71 15.9298C15.58 15.9298 15.45 15.8998 15.33 15.8198L12.23 13.9698C11.46 13.5098 10.89 12.4998 10.89 11.6098V7.50977C10.89 7.09977 11.23 6.75977 11.64 6.75977C12.05 6.75977 12.39 7.09977 12.39 7.50977V11.6098C12.39 11.9698 12.69 12.4998 13 12.6798L16.1 14.5298C16.46 14.7398 16.57 15.1998 16.36 15.5598C16.21 15.7998 15.96 15.9298 15.71 15.9298Z"
      fill="#1E90FF"
    />
  </SvgIcon>
);
